import { render } from "./AppScrollableBox.vue?vue&type=template&id=129f2538&scoped=true&bindings={\"disabled\":\"props\",\"wrapped\":\"props\",\"dark\":\"props\"}"
import script from "./AppScrollableBox.vue?vue&type=script&lang=js"
export * from "./AppScrollableBox.vue?vue&type=script&lang=js"

import "./AppScrollableBox.vue?vue&type=style&index=0&id=129f2538&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-129f2538"

export default script